/* eslint-disable @typescript-eslint/no-explicit-any */
import request from 'utils/request';

const uploadService = {
  uploadImage: (data: any) => request.post('/upload', data),
  uploadImageNomenclature: (data: any) =>
    request.post('/upload/nomenclature', data),
  deleteNomenclature: (id: any) => request.delete(`/nomenclature-photo/${id}`),
  getByIdUploadedImage: (id: any) => request.get(`/nomenclature-photo/${id}`),
  createUploadedImage: (data: any) => request.post('/nomenclature-photo', data)
};

export default uploadService;
